import React, { useState, useEffect } from 'react';

export default function UserFilter({ value, operator, onChange, items }) {
  const [localVal, setLocalVal] = useState(value);
  const [op, setOp] = useState(operator || 'contiene');

  useEffect(() => { setLocalVal(value); }, [value]);
  useEffect(() => { setOp(operator || 'contiene'); }, [operator]);

  const handleValueChange = (e) => {
    setLocalVal(e.target.value);
    onChange(e.target.value, op);
  };

  const handleOpChange = (e) => {
    setOp(e.target.value);
    onChange(localVal, e.target.value);
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <select
        className="cm-filter-select"
        value={localVal}
        onChange={handleValueChange}
      >
        <option value="">-- Todos --</option>
        {(items || []).map(item => (
          <option key={item.id} value={item.id}>{item.name}</option>
        ))}
      </select>
      <select className="cm-filter-select" value={op} onChange={handleOpChange}>
        <option value="contiene">Contiene</option>
        <option value="igual">Igual</option>
        <option value="diferente">Diferente</option>
      </select>
    </div>
  );
}
